module.exports = __webpack_public_path__ + "img/17859_S.f5d8aa40.png";